export default __webpack_public_path__ + "static/media/responsive-demo-classic-armory.86fb5d7d.png";